import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useSnackbar } from "notistack";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import { CircularProgress } from "@mui/material";

const listProjects = (loadingProjFolder, enqueueSnackbar, resultHandler) => {
  let getAPI = "/api/projects/list";
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }
  loadingProjFolder(true);
  fetch(getAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    redirect: "manual",
  })
    .then((response) => {
      if (response.type === "opaqueredirect") {
        enqueueSnackbar(
          "Failed to fetch. Hence the page will be automatically refreshed, and signin again.",
          { variant: "error" }
        );
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
        return;
      }
      if (!response.ok) {
        response
          .text()
          .then((text) => {
            throw Error(response.statusText + ": " + text);
          })
          .catch((error) =>
            enqueueSnackbar(error.message, { variant: "error" })
          );
      } else {
        response.json().then((result) => {
          const projects = result;
          resultHandler(projects);
          loadingProjFolder(false);
        });
      }
    })
    .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
};

const getFilesForProject = (
  loadingProjFile,
  resultHandler,
  enqueueSnackbar,
  projectId
) => {
  let getAPI = "/api/projects/" + projectId;
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }
  loadingProjFile(true);
  fetch(getAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        response
          .text()
          .then((text) => {
            throw Error(response.statusText + ": " + text);
          })
          .catch((error) =>
            enqueueSnackbar(error.message, { variant: "error" })
          );
      } else {
        response.json().then((result) => {
          resultHandler(result);
          loadingProjFile(false);
        });
      }
    })
    .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
};

function DialogOpenProject({ open, onCancel, onFinish }) {
  const [projects, setProjects] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedProject, setSelectedProject] = useState(false);
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [loadingProjFolder, setloadingProjFolder] = useState(false);
  const [loadingProjFile, setloadingProjFile] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (open === true) {
      // listFromCloud(setloadingProjFolder, enqueueSnackbar, (result) => {
      //   setProjects(result);
      // });
      listProjects(setloadingProjFile, enqueueSnackbar, setFiles);
    }
  }, [enqueueSnackbar, open]);

  const projectList = files.map((file) => {
    return (
      <ListItem
        button
        onClick={() => {
          onFinish(file.name, file);
          setSelectedProject(false);
        }}
        key={file.name + " by " + file.ownerName}
      >
        <ListItemText
          primary={file.name + " by " + file.ownerName}
          secondary={`Folder: ${file.folderName}`}
        />
      </ListItem>
    );
  });

  const close = () => {
    setSelectedProject(false);
    onCancel();
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setloadingProjFolder(false);
    setloadingProjFile(false);
  };

  const chooseProjectMessage = "Please choose a project:";
  const chooseFileMessage = "Please choose a file:";

  return (
    <div>
      <div>
        <Dialog
          open={open}
          onClose={close}
          aria-labelledby="form-dialog-title"
          scroll="paper"
        >
          <DialogTitle id="form-dialog-title">Open Project</DialogTitle>
          <DialogContent dividers={true}>
            <DialogContentText>
              {/* {!selectedProject ? chooseProjectMessage : chooseFileMessage} */}
              {chooseFileMessage}
            </DialogContentText>
            { /* <List>{!selectedProject ? projectListItems : fileListItems}</List> */}
            <List>{projectList}</List>
          </DialogContent>
          <DialogActions>
            <Button onClick={close} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Snackbar
        title="Load Project Folder Message"
        open={loadingProjFolder}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          <div>
            <CircularProgress color="inherit" />
            Don't close!! Please wait while project folders are being loaded it may take several minutes
          </div>
        </Alert>
      </Snackbar>
      <Snackbar
        title="Load Project File Message"
        open={loadingProjFile}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          <div>
            <CircularProgress color="inherit" />
            {/* Don't close!! Please wait while files under the selected folder are being loaded it may take several minutes */}
            Don't close!! Please wait while project files are being loaded it may take several minutes
          </div>
        </Alert>
      </Snackbar>
    </div>
  );
}

export default DialogOpenProject;
